import { render, staticRenderFns } from "./servererror.vue?vue&type=template&id=1dc4ac76&scoped=true&"
import script from "./servererror.vue?vue&type=script&lang=js&"
export * from "./servererror.vue?vue&type=script&lang=js&"
import style0 from "./servererror.vue?vue&type=style&index=0&id=1dc4ac76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc4ac76",
  null
  
)

export default component.exports